export const LISTA_ROTAS = 'LISTA_ROTAS'
export const SELECIONAR_ROTA = 'SELECIONAR_ROTA'
export const LISTAR_TODAS_TAGS = 'LISTAR_TODAS_TAGS'
export const GET_ROTA_USE = 'GET_ROTA_USE'
export const LISTAR_GRUPOS = 'LISTAR_GRUPOS'
